"use client";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { sendGAEvent } from "@next/third-parties/google";
import _debounce from "lodash/debounce";
import { useIntl } from "react-intl";
import PageLoading from "@components/Loading/PageLoading";

import Search from "../search";

const JobsSearch = () => {
  const searchParams = useSearchParams();
  const [searchTerm, setSearchTerm] = useState<string>(
    searchParams?.get("search") || ""
  );
  const [loading, setLoading] = useState(false);

  const router = useRouter();
  const intl = useIntl();
  const homeTranslation: any = intl.messages.common;

  useEffect(() => {
    setSearchTerm(searchParams.get("search") || "");
    setLoading(false);
  }, [searchParams]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setSearchTerm(e.target.value);
  };

  const getCustomEventName = (value: string) => ({
    [process.env.NEXT_PUBLIC_JOB_SEARCH_EVENT as string]: value,
  });

  const handleSearchJobs = (term: string) => {
    setLoading(true);

    setSearchTerm(term);
    sendGAEvent("event", "job_search", getCustomEventName(term));
    router.push(
      `/jobs?page=1${term ? `&search=${term}` : ""}${
        searchParams?.get("sort_by")
          ? `&sort_by=${searchParams?.get("sort_by")}`
          : ""
      }`
    );
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    handleSearchJobs(searchTerm);
  };

  return (
    <div className="mx-auto relative search-section-container text-gray-700 z-10">
      {loading ? <PageLoading /> : null}

      <Search
        placeholder={homeTranslation["search-job-placeholder"]}
        btnText={homeTranslation["search-jobs"]}
        value={searchTerm}
        onChange={handleInputChange}
        handleCancel={() => handleSearchJobs("")}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default JobsSearch;
